module.exports = __webpack_public_path__ + "static/media/1006133.cf6f71bc.png";